<!-- Dialog: CLEAR OPS INT EVENT -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="false"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header class="dialog__header__ops-int-clear"> {{ data.dialogData.title_text }} </p-header>
  <div class="dialog__body__ops-int-clear">
    <div>
      <div class="p-autocomplete-float-group">
        <label for="client">IDs</label>
        <bfx-text-input
          size="sm"
          inputText
          #copyFilter_filterName_autoComplete
          [(ngModel)]="data.dialogData.refs"
          [ngModelOptions]="{standalone: true}"
          autoHighlight="true"
          appendTo="body"
          [style]="{'width':'100%'}"
          [ngClass]="{'p-autocomplete p-autocomplete-float-input clear__dialog__ops-int-clear__autocomplete--referencedDataIDs': true,
                      'p-autocomplete-float-input-valid': !!data.dialogData.refs}"
          [disabled]="true"
        >
        </bfx-text-input>
      </div>
    </div>
    <div>
      <div class="p-autocomplete-float-group">
        <label for="client">Manual Deal Ref</label>
        <bfx-text-input
          size="sm"
          #clear_field_manualDealRef
          [(ngModel)]="data.dialogData.manualDealRef"
          field="label"
          (blur)="validateManualDealRefOnBlur($event)"
          (focus)="onFocusManualDealRef($event)"
          autoHighlight="true"
          appendTo="body"
          dataKey="value"
          delay="4"
          maxLength="250"
          [style]="{'width':'100%'}"
          [ngClass]="{'p-autocomplete p-autocomplete-float-input clear__dialog__ops-int-clear__autocomplete--manualDealRef': true, 'p-autocomplete-float-input-valid': !!data.dialogData.manualDealRef}"
        >
        </bfx-text-input>
        <!-- <div class="p-autocomplete-float-label-error" [ngStyle]="{ visibility: manualDealRefEmpty || manualDealRefValid ? 'hidden' : 'visible'}">{{data.dialogData.message_manual_def_ref_invalid}}</div> -->
      </div>
    </div>
    <div>
      <label for="client">{{data.dialogData.placeholder}}</label>
      <textarea
        pInputTextarea
        #clear_field_comment
        class="clear__dialog__clear-comment__content-comment"
        (blur)="validateClearCommentOnBlur($event)"
        (focus)="onFocusClearComment($event)"
        [ngClass]="clearCommentInvalid ? 'clear__dialog__clear-comment__content-comment--invalid' : 'clear__dialog__clear-comment__content-comment--valid'"
        [(ngModel)]="data.dialogData.comment"
        maxlength="250"
        rows="4"
        cols="62"
        autoResize="false"
      ></textarea>
      <bfx-comment-warning></bfx-comment-warning>
    </div>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionClearOpsInt_cancel()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionClearOpsInt_submit()"
      label="Clear"
      [disabled]="isSubmitDisabled()"
    ></button>
  </p-footer>
</p-dialog>
